import { defineComponent, h, PropType } from 'vue';
import { clipping_model_editable, clipping_on, toggle_clipping, ToggleClippingTooltip } from '..';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import toggle_clipping_svg from '../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/toggle_clipping.svg';
import { img } from '@phi/components';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ToggleClippingIcon = toggle_clipping_svg;

export const ToggleClipping = defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Set section planes';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled) return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else toggle_clipping();
        }
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    render() {
        return h(BarButton, {
            id: 'toggle-clipping-button',
            tippy: 'right',
            active: clipping_on.value || clipping_model_editable.value,
            disabled: this.disabled,
            selected: this.state.tut_stage === 3,
            onClick: this.onClick,
            help: 'toggle_clipping',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_clipping_svg, this.alt),
            tooltip: ToggleClippingTooltip,
        });
    },
});
